import { Link } from 'react-router-dom';
import { Sun, Moon, Globe } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { useLanguage } from '../context/LanguageContext';
import { useCurrency } from '../context/CurrencyContext';
import NotificationBell from './NotificationBell';

/**
 * Mobile top bar with brand + language + currency + dark mode toggles.
 */
export const TopBar = ({ title, showBrand = true, right = null }) => {
  const { theme, toggleTheme } = useTheme();
  const { language, toggleLanguage } = useLanguage();
  const { currency, toggleCurrency } = useCurrency();

  return (
    <header
      className="sticky top-0 z-40 bg-background/85 backdrop-blur-xl border-b border-border"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <div className="flex items-center justify-between px-4 h-14">
        <div className="flex items-center gap-2 min-w-0">
          {showBrand && (
            <Link to="/" className="font-heading text-xl font-bold truncate">
              Bid<span className="text-caribbean">Trip</span>
            </Link>
          )}
          {title && (
            <h1 className="font-heading text-base font-semibold truncate text-foreground">
              {title}
            </h1>
          )}
        </div>
        <div className="flex items-center gap-1">
          {right}
          <NotificationBell />
          <button
            onClick={toggleCurrency}
            data-testid="currency-toggle"
            className="h-9 min-w-[44px] px-2 rounded-full flex items-center justify-center text-[11px] font-bold text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
            aria-label={`Switch currency, current ${currency}`}
            title={currency === 'USD' ? 'Switch to MXN' : 'Cambiar a USD'}
          >
            {currency}
          </button>
          <button
            onClick={toggleLanguage}
            data-testid="lang-toggle"
            className="w-9 h-9 rounded-full flex items-center justify-center text-muted-foreground hover:bg-muted transition-colors"
            aria-label="Toggle language"
          >
            <Globe size={18} />
            <span className="sr-only">{language}</span>
          </button>
          <button
            onClick={toggleTheme}
            data-testid="theme-toggle"
            className="w-9 h-9 rounded-full flex items-center justify-center text-muted-foreground hover:bg-muted transition-colors"
            aria-label="Toggle theme"
          >
            {theme === 'light' ? <Moon size={18} /> : <Sun size={18} />}
          </button>
        </div>
      </div>
    </header>
  );
};
